import Vue from 'vue'
import VueCookies from 'vue-cookies'
import { AUTH_COOKIE_NAME, ONE_DAY_IN_SECONDS, THIRTY_DAYS_IN_SECONDS } from '@/utils/constants'
import { isNull } from '@/utils/comparators'
import { EventBus } from '@/utils/eventBus'
import moment from 'moment'
import { authenticateUser } from '@/api/user'
import { createSession } from '@/api/base'
import { getPlatformInfo, getBrowserInfo } from '@/utils/browser'

Vue.use(VueCookies)

const Auth = new Vue({
  data () {
    return {
      cookieDomain: process.env.COOKIE_DOMAIN,
      version: { os: getBrowserInfo(), platform: getPlatformInfo(), application: 'Rebtel SPA' },
      expiresIn: null
    }
  },
  methods: {
    async authenticate (normalizedNumber, pin, stayLoggedIn) {
      try {
        this.expiresIn = stayLoggedIn ? THIRTY_DAYS_IN_SECONDS : ONE_DAY_IN_SECONDS

        let endpointPath = `${normalizedNumber.type}/${normalizedNumber.endpoint}`
        let authenticationResponse = await authenticateUser(normalizedNumber.endpoint, pin)
        let instanceResponse = await createSession(authenticationResponse.authorization, this.expiresIn, this.version)

        this.setStoredSession(instanceResponse.id, instanceResponse.secret, endpointPath)
        return Promise.resolve(authenticationResponse.user.id)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    setStoredSession (sessionid, secret, endpointPath) {
      let cookieValue = {
        sessionId: sessionid,
        sessionSecret: secret,
        endpointPath: endpointPath
      }
      this.$cookies.set(AUTH_COOKIE_NAME, cookieValue, this.expiresIn, '/', process.env.COOKIE_DOMAIN)
    }
  }
})

/**
* If no auth cookie exist redirect user to login page.
*/
const requireAuth = (to, from, next) => {
  if (!isLoggedIn()) {
    EventBus.emitUnauthorizedEvent({ returnUrl: to.fullPath, locale: to.params.locale })
  } else {
    next()
  }
}

/**
* Returns true if the user is logged in.
*/
const isLoggedIn = () => {
  let hasCookie = authCookie() !== undefined
  return hasCookie
}

/**
* Returns the content of the auth cookie
*/
const authCookie = () => {
  let value = '; ' + document.cookie
  let parts = value.split('; ' + AUTH_COOKIE_NAME + '=')
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }
}

const setServerTimestampDiff = (serverTime) => {
  let diff = 0
  if (!isNull(serverTime)) {
    let correctFormat = moment(new Date(serverTime)).utc().format('M/D/YYYY h:mm:ss A')
    let serverUtcDate = new Date(correctFormat)
    let clientDate = new Date()
    let clientDateUtc = new Date(clientDate.getTime() + clientDate.getTimezoneOffset() * 60000)
    diff = serverUtcDate - clientDateUtc
  }
  window.serverTimestampDiff = diff
}

export {
  Auth,
  requireAuth,
  isLoggedIn,
  authCookie,
  setServerTimestampDiff
}



// WEBPACK FOOTER //
// ./src/utils/auth.js